module.exports = __webpack_public_path__ + "img/pro-m-slider22.c3972e5a.jpg";